import React, { Component } from "react";
import Tooltip from "@mui/material/Tooltip";
import HelpFilledIcon from "@mui/icons-material/Help";
import fetch, { fetchM } from "../../../utils/fetch";
import { isEmpty } from "lodash";

// Maps MUI v0 tooltipPosition to MUI v5 placement
const toPlacement = (pos) => {
  const map = {
    "top-left": "top-start",
    "top-right": "top-end",
    "top-center": "top",
    "bottom-left": "bottom-start",
    "bottom-right": "bottom-end",
    "bottom-center": "bottom",
  };
  return map[pos] || "top";
};

export default class HelpIcon extends Component {
  static defaultProps = {
    tooltipPosition: "top-left",
  };

  state = {
    tooltip: "Načítám...",
  };

  async componentDidMount() {
    const { helpEnum } = this.props;
    await this.loadText(helpEnum);
  }

  async componentWillReceiveProps(nextProps) {
    const { helpEnum } = nextProps;
    if (this.props.helpEnum !== helpEnum) {
      await this.loadText(helpEnum);
    }
  }

  loadText = async (helpEnum) => {
    try {
      const response = await fetchM(
          `/api/help/placements/${helpEnum}`
      );

      if (response && response.ok) {
        const helpText = await response.text();
        this.setState({ tooltip: isEmpty(helpText) ? "Chybí text" : helpText });
      } else {
        this.setState({ tooltip: "Chybí text" });
      }
    } catch (e) {
      this.setState({ tooltip: "Chybí text" });
    }
  };

  render() {
    const { tooltipPosition, helpEnum, style, disabled, dispatch, ...props } =
      this.props;

    if (disabled) return null;

    const size = (style && style.width) || "20px";

    return (
      <Tooltip
        title={this.state.tooltip}
        placement={toPlacement(tooltipPosition)}
        arrow
        enterDelay={200}
        aria-label={null}
        componentsProps={{
          tooltip: {
            sx: {
              bgcolor: "rgba(97, 97, 97, 0.92)",
              color: "#fff",
              fontSize: "12px",
              maxWidth: 280,
              p: "8px 10px",
              borderRadius: "2px",
              lineHeight: 1.35,
              whiteSpace: "pre-wrap",
            },
          },
          arrow: {
            sx: { color: "rgba(97, 97, 97, 0.92)" },
          },
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: size,
            height: size,
            cursor: "pointer",
            flexShrink: 0,
            ...style,
          }}
        >
          <HelpFilledIcon
            className="helpIconSvg"
            style={{
              width: size,
              height: size,
              display: "block",
              color: "rgba(97, 97, 97, 0.75)",
            }}
          />
        </span>
      </Tooltip>
    );
  }
}
